import Vue from 'vue'
import {i18N} from '@/main'

console.log("APP",app)

const states = {
}

const actions = {
  setLang({commit}, payload) {
    commit("updateLang", payload)
  }
}

const mutations ={
  updateLang (state, payload) {
    i18N.locale = payload
  }
}

const getters = {

}

export default {
    states,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/lang.js